import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Plus, Eye, Download, ExternalLink, Pencil, Trash2, Copy } from "lucide-react";
import api from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";

export default function CardsList() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = () => api.get("/cards").then((r) => setCards(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this card?")) return;
    await api.delete(`/cards/${id}`);
    toast.success("Card deleted");
    load();
  };

  const copyLink = (slug) => {
    navigator.clipboard.writeText(`${window.location.origin}/c/${slug}`);
    toast.success("Public link copied");
  };

  return (
    <DashboardLayout title="My Cards"
      actions={<Link to="/app/cards/new" className="btn-gold px-4 py-2.5 rounded-full text-sm flex items-center gap-2" data-testid="new-card-btn"><Plus size={16} /> New Card</Link>}>
      {loading ? <p className="text-[#8B9BB4]">Loading…</p> :
        cards.length === 0 ? (
          <div className="iw-card p-12 text-center">
            <h3 className="font-display text-2xl font-bold">No cards yet</h3>
            <p className="text-[#8B9BB4] mt-2 mb-6">Create your first digital business card.</p>
            <Link to="/app/cards/new" className="btn-gold px-6 py-3 rounded-full inline-block">Create Card</Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
            {cards.map((c) => (
              <div key={c.id} className="iw-card p-6" data-testid={`card-item-${c.id}`}>
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="font-display text-xl font-bold">{c.full_name || "Untitled"}</h3>
                    <p className="text-sm text-[#D4AF37]">{c.job_title}</p>
                    <p className="text-xs text-[#8B9BB4] mt-0.5">{c.company}</p>
                  </div>
                  <span className="h-3 w-3 rounded-full" style={{ background: c.brand_color }} />
                </div>
                <div className="flex gap-4 mt-4 text-sm text-[#8B9BB4]">
                  <span className="flex items-center gap-1"><Eye size={14} /> {c.view_count}</span>
                  <span className="flex items-center gap-1"><Download size={14} /> {c.save_count}</span>
                </div>
                <div className="flex flex-wrap gap-2 mt-5">
                  <button onClick={() => navigate(`/app/cards/${c.id}`)} className="btn-ghost px-3 py-2 rounded-lg text-xs flex items-center gap-1.5" data-testid={`edit-${c.id}`}><Pencil size={13} /> Edit</button>
                  <a href={`/c/${c.slug}`} target="_blank" rel="noreferrer" className="btn-ghost px-3 py-2 rounded-lg text-xs flex items-center gap-1.5"><ExternalLink size={13} /> View</a>
                  <button onClick={() => copyLink(c.slug)} className="btn-ghost px-3 py-2 rounded-lg text-xs flex items-center gap-1.5"><Copy size={13} /> Link</button>
                  <button onClick={() => del(c.id)} className="px-3 py-2 rounded-lg text-xs flex items-center gap-1.5 text-red-400 border border-red-400/30 hover:bg-red-400/10 transition-colors" data-testid={`delete-${c.id}`}><Trash2 size={13} /></button>
                </div>
              </div>
            ))}
          </div>
        )}
    </DashboardLayout>
  );
}
